import { colors } from 'fitify-ui'
import { baseTextVariants } from 'fitify-ui-landing/src/components/Text/Text.Styled'
import merge from 'lodash/merge'
import type { ReactNode } from 'react'
import { type DefaultTheme, ThemeProvider } from 'styled-components'

export enum ThemeVariants {
  HC = 'hc',
  DIGITAL = 'digital',
}

export const baseTheme: DefaultTheme = {
  colors: colors,
  textVariants: baseTextVariants,
}

export const FitifyThemeProvider = ({
  children,
  theme,
}: {
  children?: ReactNode | undefined
  theme: DefaultTheme
}) => {
  const composedTheme = merge({}, baseTheme, theme)
  return <ThemeProvider theme={composedTheme}>{children}</ThemeProvider>
}
